export default __webpack_public_path__ + "static/media/whatsapp.b06d2234.svg";